import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "hierarchy",
      header: "Hierarchy",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>
          {row.original.level}.{row.original.order}
        </div>
      ),
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
    },
    {
      accessorKey: "parent.code",
      header: "Parent ID",
      cell: ({ row }) => <div>{row.original.parent?.code}</div>,
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
    {
      accessorKey: "icon_url",
      header: "Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "is_icon_bordered",
      header: "Icon Border?",
      cell: ({ row }) => (
        <div>{row.getValue("is_icon_bordered") ? "Yes" : "No"}</div>
      ),
      enableResizing: false,
      enableSorting: false,
    },
  ];
};
